module.exports = __webpack_public_path__ + "img/193.65c0ff32.jpg";